<template>
  <DefaultLayout
          :steps-area-title="stepsAreaTitle"
          :steps="steps"
          :features-area-title="featuresAreaTitle"
          :features="features"
  >
    <div class="uploadAreaWrapper">
      <div class="uploadAreaContainer">
        <div class="uploadAreaTitle">{{ pageTitle }}</div>
        <div class="homePageContainer">
          <AsideNav :menus="menus" class="asideNav" />
          <UploadFile
                  :accept="accept"
                  :limit="limit"
                  :max-size="maxSize"
                  @onExceed="onUploadExceed"
                  @onSuccess="onUploadSuccess"
                  v-if="files.length === 0"
                  class="uploadFileComponent"
          />
          <div v-else class="fileListComponent">
            <div class="fileListContainer">
              <div class="cardTitleBox">
                <div class="title">文件列表</div>
                <div class="btnGroups">
                  <button class="btn" @click="handleReUpload">重新上传</button>
                  <UploadFileBtn
                          :accept="accept"
                          :limit="limit"
                          @onExceed="onUploadExceed"
                          @onSuccess="onUploadSuccess"
                  >
                    <button class="btn">
                      <span class="icon upload_icon"></span>
                      添加图片
                    </button>
                  </UploadFileBtn>
                  <button
                          v-if="isExecute"
                          class="btn download_btn"
                          @click="handleDownloadAll"
                  >
                    <span class="icon download_icon"></span>
                    全部下载
                  </button>
                  <!-- <button
                    v-if="isShowFangdaTips"
                    class="btn download_btn"
                    @click="FangDaDownLoad"
                  >
                    <span class="icon download_icon"></span>
                    全部下载
                  </button> -->
                </div>
              </div>
              <div class="cardList">
                <FileCard3
                        :file="file"
                        v-for="(file, idx) in files"
                        :key="idx"
                        :molti="molti"
                        ref="cardRef"
                        class="cardItem"
                        @onPreview="handlePreview"
                        @onFD="handlefangda"
                        @download="downloadFile"
                        @onFDload="FangDaDownLoad"
                        @remove="onRemoveFile(idx)"
                />
              </div>
              <div class="controlContainer">
                <div v-if="handlingMethod === 'edit'" class="paramsSettingBox">
                  <div class="paramItem">
                    <el-radio label="sameScale" v-model="checkRadio">
                      <span class="label">等比例缩放：</span>
                      <el-select v-model="params.scale" placeholder="请选择">
                        <el-option
                                :label="scale.title"
                                :value="scale.value"
                                v-for="scale in scales"
                                :key="scale.value"
                        ></el-option>
                      </el-select>
                    </el-radio>
                  </div>
                  <div class="paramItem" style="margin-left: 56px">
                    <el-radio
                            label="customScale"
                            v-model="checkRadio"
                            class="customScaleRadio"
                    >
                      <span class="label">指定尺寸：</span>
                      <div class="inputBox">
                        <el-tooltip
                                content="输入数值后压缩并自动修改图片宽度"
                                placement="top"
                        >
                          <div class="inputContainer">
                            <el-input-number
                                    :controls="false"
                                    :min="0"
                                    placeholder="原尺寸"
                                    class="input"
                                    @focus="handleFocus"
                                    v-model="params.width"
                            ></el-input-number>
                            <span>宽</span>
                          </div>
                        </el-tooltip>
                        <span class="chaIcon"></span>
                        <el-tooltip
                                content="留空则按宽度比自动计算高度"
                                placement="top"
                        >
                          <div class="inputContainer">
                            <el-input-number
                                    :controls="false"
                                    :min="0"
                                    placeholder="原尺寸"
                                    class="input"
                                    @focus="handleFocus"
                                    v-model="params.height"
                            ></el-input-number>
                            <span>高</span>
                          </div>
                        </el-tooltip>
                        <span class="txt">px</span>
                      </div>
                    </el-radio>
                  </div>
                  <button class="startBtn" @click="execute">立即修改</button>
                </div>
                <div
                        v-else-if="handlingMethod === 'changeDpi'"
                        class="paramsSettingBox"
                >
                  <div class="paramItem">
                    <span class="label">选择DPI：</span>
                    <el-select
                            v-model="params.dpi"
                            popper-class="selectWrap"
                            placeholder="请选择"
                    >
                      <el-option
                              :label="dpi.title"
                              :value="dpi.value"
                              v-for="dpi in dpiList"
                              :key="dpi.value"
                      ></el-option>
                    </el-select>
                  </div>
                  <button class="startBtn" @click="execute">立即修改</button>
                </div>
                <div
                        v-else-if="handlingMethod === 'increaseMemory'"
                        class="paramsSettingBox"
                >
                  <div class="paramItem">
                    <el-radio value="1" label="1">
                      指定大小
                      <el-tooltip
                              content="仅改变图片内存，不降低清晰度"
                              placement="top"
                      >
                        <el-input-number
                                v-model="params.size"
                                :controls="false"
                                :min="0"
                                @input.native="reducedUnit"
                                class="inputNumber"
                        />
                      </el-tooltip>
                      KB = {{ reduceMBUnit }} 兆（MB）
                    </el-radio>
                  </div>
                  <button class="startBtn" @click="execute">立即修改</button>
                </div>
                <div
                        v-else-if="handlingMethod === 'losslessAmplification'"
                        class="paramsSettingBox"
                >
                  <div class="CompressBox">
                    <div class="paramItem">
                      <span class="label">放大倍数参数：</span>
                      <el-radio-group
                              v-model="molti"
                              class="groups"
                              style="margin-top: 2px"
                      >
                        <el-radio label="2">2X</el-radio>
                        <el-radio label="4">4X</el-radio>
                        <el-radio label="6">6X</el-radio>
                        <el-radio label="8">8X</el-radio>
                      </el-radio-group>
                      <el-checkbox
                              v-model="denoise"
                              style="margin-top: 2px; margin-left: 50px"
                      >自动降噪</el-checkbox
                      >
                    </div>
                    <button class="startBtn" @click="Amplification">
                      开始放大
                    </button>
                  </div>
                </div>
                <div
                        v-else-if="handlingMethod === 'clearnessAamplification'"
                        class="paramsSettingBox"
                >
                  <div class="CompressBox">
                    <div class="paramItem">
                      <span class="label">图片增强设置：</span>
                      <el-radio-group
                              v-model="molti"
                              class="groups"
                              style="margin-top: 2px"
                      >
                        <el-radio label="0">原尺寸</el-radio>
                        <el-radio label="2">2X</el-radio>
                        <el-radio label="4">4X</el-radio>
                      </el-radio-group>
                    </div>
                    <button class="startBtn" @click="Amplification">
                      开始增强
                    </button>
                  </div>
                </div>

                <!-- 老照片修复 -->
                <div
                        v-else-if="handlingMethod === 'laozhaopian'"
                        class="paramsSettingBox"
                >
                  <div class="CompressBox">
                    <div class="paramGroups">
                      <div class="paramItem">
                        <el-radio-group v-model="params.modelType" class="groups" style="margin-top: 3px" @input="onSelectModelType">
                          <el-radio  :label="1">修复模型一：</el-radio>
                        </el-radio-group>
                      </div>
                      <div class="paramItem">
                        <span class="label">是否上色：</span>
                        <el-radio-group
                                v-model="params.colorType"
                                :disabled="params.modelType !== 1"
                                class="groups"
                                style="margin-top: 2px"
                        >
                          <el-radio :label="1">是</el-radio>
                          <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                      </div>
                    </div>
                    <div class="paramGroups">
                      <div class="paramItem">
                        <el-radio-group v-model="params.modelType" class="groups" style="margin-top: 3px" @input="onSelectModelType">
                          <el-radio  :label="2">修复模型二：</el-radio>
                        </el-radio-group>
                      </div>
                      <div class="paramItem">
                        <span class="label">修复模式：</span>
                        <el-radio-group
                                v-model="params.fix_mode"
                                class="groups"
                                :disabled="params.modelType !== 2"
                                style="margin-top: 2px"
                        >
                          <el-radio :label="0">通用</el-radio>
                          <el-radio :label="1">人像</el-radio>
                        </el-radio-group>
                      </div>
                      <div class="paramItem">
                        <span class="label">输出尺寸：</span>
                        <el-radio-group
                                v-model="params.outputSize"
                                class="groups"
                                :disabled="params.modelType !== 2"
                                style="margin-top: 2px"
                        >
                          <el-radio :label="0">推荐大小</el-radio>
                          <el-radio :label="1">原尺寸</el-radio>
                          <!--                        <el-radio :label="2">2倍</el-radio>-->
                          <!--                        <el-radio :label="4">4倍</el-radio>-->
                        </el-radio-group>
                      </div>
                    </div>

                    <button class="startBtn" @click="Amplification">
                      开始修复
                    </button>
                  </div>
                </div>
                <!-- 图片上色 -->
                <div
                        v-else-if="handlingMethod === 'upcolor'"
                        class="paramsSettingBox"
                >
                  <div class="CompressBox">
                    <div class="paramItem">
                      <span class="label">输出格式：</span>
                      <el-radio-group
                              v-model="params.colorShiftingOutputFormat"
                              class="groups"
                              style="margin-top: 2px"
                      >
                        <el-radio :label="0">JPG</el-radio>
                        <el-radio :label="1">PNG</el-radio>
                        <el-radio :label="2">WEBP</el-radio>
                      </el-radio-group>
                    </div>

                    <button class="startBtn" @click="Amplification">
                      开始上色
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PreviewModal
            :dialog-visible="visible"
            :file-info="fileInfo"
            :molti="molti"
            @onClose="handleClosePreview"
    />
    <!-- 放大时预览的组件 -->
    <PreviewModalFD
            :molti="molti"
            :dialog-visible="isShowFangdaTitle"
            :file-info="fileInfo"
            @onClose="handleClosePreviewFd"
    />
    <MessageDialog
            :dialog-visible="isShowTips"
            :show-left="false"
            :show-right="true"
            right-btn-txt="知道了"
            @onClickRightBtn="handleClickRight"
            @onClose="handleClickRight"
    >
      单次上传文件不得超过{{ limit }}个
    </MessageDialog>
    <MessageDialog
            :dialog-visible="isShowExceedTips"
            :show-left="false"
            :show-right="true"
            right-btn-txt="知道了"
            @onClickRightBtn="handleExceedClickRight"
            @onClose="handleExceedClickRight"
    >
      单个文件大小不得超过100MB
    </MessageDialog>
    <MessageDialog
            :dialog-visible="isShowBuyTips"
            :show-left="false"
            :show-right="true"
            left-btn-txt="残忍放弃"
            right-btn-txt="开通VIP"
            @onClickRightBtn="handleBuyClickRight"
            @onClose="handleBuyClickLeft"
            @onClickLeftBtn="handleBuyClickLeft"
    >
      您的文件已处理成功，离开文件将丢失确认要放弃吗？
    </MessageDialog>
    <MessageDialog
            :dialog-visible="isShowExceedDownloadTips"
            :show-left="false"
            :show-right="true"
            left-btn-txt="残忍放弃"
            right-btn-txt="限时升级VIP"
            @onClickRightBtn="handleExceedDownloadClickRight"
            @onClose="handleExceedDownloadClickLeft"
            @onClickLeftBtn="handleExceedDownloadClickLeft"
    >
      您的下载次数已用完！
    </MessageDialog>
    <MessageDialog
            :dialog-visible="isShowReUploadTips"
            :show-left="true"
            :show-right="true"
            left-btn-txt="取消"
            right-btn-txt="重新上传"
            @onClickRightBtn="handleReUploadClickRight"
            @onClose="handleReUploadClickLeft"
            @onClickLeftBtn="handleReUploadClickLeft"
    >
      重新上传前先下载保存当前文件，是否重新上传？
    </MessageDialog>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import UploadFile from '@/components/UploadFile/index.vue'
import AsideNav from '@/components/AsideNav/index.vue'
import { headerMenus } from '../../config/menus.config'
import { COMPRESS_UPLOAD_CONFIG, VIP_LEVEL } from '@/config'
import MessageDialog from '@/components/MessageDialog/index.vue'
import UploadFileBtn from '@/components/UploadFileBtn/index.vue'
import FileCard3 from '@/components/FileCard3/index.vue'
import { mapActions, mapGetters } from 'vuex'
import { batchDownload, singleDownload } from '@/utils'
import { checkUserImage, duce } from "@/api";
import { Message } from 'element-ui'
import PreviewModal from '@/components/PreviewModal/index.vue'
import PreviewModalFD from '@/components/PreviewModalFD/index.vue'
import { formatTypes } from '../../config'
import {
  IMG_EDIT_PAGE_CONFIG,
  IMG_EDIT_PAGE_CONFIG_AMPLIFICATION,
  IMG_EDIT_PAGE_CONFIG_CLEARNESS,
  LAOZHAOPIAN
} from '@/config/page.config'
import { METHODS } from '@/api'
import { getFileInfo } from '@/utils'
import isEmpty from 'lodash-es/isEmpty'
import { getToken } from "@/utils/token";
import { getImageFileSize } from "@/utils/getImageFileInfo";

export default {
  name: 'editHome',
  metaInfo() {
    return {
      ...this.tdk
    }
  },
  components: {
    PreviewModal,
    FileCard3,
    UploadFileBtn,
    AsideNav,
    UploadFile,
    DefaultLayout,
    MessageDialog,
    PreviewModalFD
  },
  data() {
    return {
      tdk: {},
      accept: '.png,.jpg,.jpeg,.bmp,.gif,.webp',
      limit: COMPRESS_UPLOAD_CONFIG.COUNTS,
      menus: [],
      stepsAreaTitle: IMG_EDIT_PAGE_CONFIG.STEP_TITLE,
      steps: IMG_EDIT_PAGE_CONFIG.STEPS,
      featuresAreaTitle: IMG_EDIT_PAGE_CONFIG.FEATURES_TITLE,
      features: IMG_EDIT_PAGE_CONFIG.FEATURES,
      pageTitle: '',

      scales: [
        {
          title: '原图100%（默认）',
          value: 100
        },
        {
          title: '90%',
          value: 90
        },
        {
          title: '80%',
          value: 80
        },
        {
          title: '70%',
          value: 70
        },
        {
          title: '60%',
          value: 60
        },
        {
          title: '50%',
          value: 50
        },
        {
          title: '40%',
          value: 40
        },
        {
          title: '30%',
          value: 30
        },
        {
          title: '20%',
          value: 20
        },
        {
          title: '10%',
          value: 10
        }
      ],
      isShowTips: false,
      isShowBuyTips: false,
      isShowReUploadTips: false,
      isShowExceedTips: false,
      isShowExceedDownloadTips: false,
      visible: false, // 预览弹窗的显示与隐藏
      files: [], // 文件列表
      fileInfo: {}, // 当前预览的文件
      checkRadio: 'sameScale', // 默认选择等比例缩放
      handlingMethod: 'edit', // changeDpi
      dpiList: COMPRESS_UPLOAD_CONFIG.DPI,
      params: {
        scale: 100,
        width: undefined,
        height: undefined,
        dpi: 72,
        size: 0,
        fix_mode: -1,
        colorType: 1,
        modelType: 1,
        outputSize: -1,
        colorShiftingOutputFormat: 0
      },
      reduceMBUnit: 0,
      isExecute: false, // 判断是否执行过
      molti: '4', // 选择的放大设置
      enhance: 'Original', // 选择的增强设置
      isShowFangdaTips: false,
      isShowFangdaTitle: false,
      denoise: true, //图片无损放大降噪，不可更改默认选中
      maxSize: 100
    }
  },

  computed: {
    ...mapGetters(['getAllCert', 'isVip', 'isLogin']),
    allCert() {
      return this.getAllCert
    },
    isUserLogin() {
      return this.isLogin
    },
    userIsVip() {
      return this.isVip
    }
  },
  watch: {
    // 监听路由变化
    $route: {
      handler(val) {

        if (this.$route.path === '/') {
          this.features = IMG_EDIT_PAGE_CONFIG_AMPLIFICATION.FEATURES
          this.steps = IMG_EDIT_PAGE_CONFIG_AMPLIFICATION.STEPS
          this.stepsAreaTitle = IMG_EDIT_PAGE_CONFIG_AMPLIFICATION.STEP_TITLE
        } else if (
                this.$route.path === '/edit/size' ||
                this.$route.path === '/edit/dpi' ||
                this.$route.path === '/edit/increase-memory'
        ) {
          this.features = IMG_EDIT_PAGE_CONFIG.FEATURES
          this.steps = IMG_EDIT_PAGE_CONFIG.STEPS
          this.stepsAreaTitle = IMG_EDIT_PAGE_CONFIG.STEP_TITLE
        } else if (this.$route.path === '/edit/hd') {
          this.features = IMG_EDIT_PAGE_CONFIG_CLEARNESS.FEATURES
          this.steps = IMG_EDIT_PAGE_CONFIG_CLEARNESS.STEPS
          this.stepsAreaTitle = IMG_EDIT_PAGE_CONFIG_CLEARNESS.STEP_TITLE
        } else if (
                this.$route.path === '/edit/laozhaopian' ||
                this.$route.path === '/edit/upcolor'
        ) {
          this.features = LAOZHAOPIAN.FEATURES
          this.steps = LAOZHAOPIAN.STEPS
          this.stepsAreaTitle = LAOZHAOPIAN.STEP_TITLE
        }

        if (this.$route.path === '/edit/laozhaopian') {
          this.maxSize = 30
          this.onSelectModelType(1) // 默认选择模型1
        } else {
          this.maxSize = 100
        }
        this.onRouterChange(val)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'showLoginModal',
      'showPurchaseModal',
      'updateUserInfo',
      'setOnPurchaseModalHidden',
      'setCanFreeDownloadFiles'
    ]),
    reducedUnit(e) {
      this.reduceMBUnit = (e.target.value / 1024)?.toFixed(2)
    },
    // 路由变化时执行
    async onRouterChange(route) {
      if (this.$route.path === '/' || this.$route.path.indexOf('/edit') != -1) {
        let asideMenus = headerMenus.filter(item => item.key === 'edit')
        if (asideMenus.length !== 0) {
          this.menus = asideMenus[0]?.children
          // console.log(this.menus)
        }
      }

      const { accept, pageTitle, handlingMethod, limit, tdk } = route.meta
      this.tdk = {
        title: tdk?.title,
        meta: [
          {
            name: 'keywords',
            content: tdk?.keywords
          },
          {
            name: 'description',
            content: tdk?.description
          }
        ]
      }
      this.accept = accept
      this.limit = limit
      this.pageTitle = pageTitle
      this.handlingMethod = handlingMethod
      this.resetData()
      // let { code } = this.$route.query
      // if (code) {
      //   await this.$store.dispatch('login', { code })
      // }
    },
    // 移除文件
    onRemoveFile(idx) {
      this.files.splice(idx, 1)
      if (this.files.length === 0) {
        this.resetData()
      }
    },
    handleFocus() {
      this.checkRadio = 'customScale'
    },

    handleExceedDownloadClickRight() {
      this.isShowExceedDownloadTips = false
      this.showPurchaseModal()
    },
    handleExceedDownloadClickLeft() {
      this.isShowExceedDownloadTips = false
    },
    handleExceedClickRight() {
      this.isShowExceedTips = false
    },
    handleBuyClickRight() {
      this.isShowBuyTips = false
      this.showPurchaseModal()
      // this.setOnPurchaseModalHidden(() => {
      //   this.isShowBuyTips = true
      // })
    },
    handleBuyClickLeft() {
      this.isShowBuyTips = false
    },
    handleReUploadClickLeft() {
      this.isShowReUploadTips = false
    },
    handleReUploadClickRight() {
      this.isShowReUploadTips = false
      this.resetData()
    },

    // 打开预览放大弹窗
    handlefangda(fileInfo) {
      this.fileInfo = fileInfo
      this.fileInfo.target.src = localStorage.getItem('imgUrl')
      this.isShowFangdaTitle = true
    },
    // 关闭预览放大弹窗
    handleClosePreviewFd() {
      localStorage.removeItem('imgUrl')
      this.isShowFangdaTitle = false
    },
    // 打开预览弹窗
    handlePreview(fileInfo) {
      this.fileInfo = fileInfo
      this.visible = true
    },
    // 关闭预览弹窗
    handleClosePreview() {
      this.visible = false
    },
    // 检查是否允许下载
    async checkAllowDownload() {
      // 检查是否登录
      if (!getToken()) {
        this.showLoginModal()
        return false
      }
      await this.$store.dispatch('updateUserInfo')

      return true
      /**
       * XXX: 这几个页面因为后端代扣除了用户权益，只为解决当用户只购买了1次的时候 前端在下载的时候用户就不是vip了
       */
      // let writeRouter = ['laozhaopian', 'clearness-amplification', 'lossless-amplification', 'upcolor']
      // if (!writeRouter.includes(this.$route.name)) {
      //   // 检查用户是否是vip
      //   if (!this.userIsVip) {
      //     this.showPurchaseModal()
      //     // this.setOnPurchaseModalHidden(() => {
      //     //   this.isShowBuyTips = true
      //     // })
      //     return false
      //   }
      //   return true
      // } else {
      //   return true
      // }


    },
    // 选择修复模型
    onSelectModelType(value) {
      if (value === 1) {
        this.params.colorType = 1

        this.params.outputSize = -1
        this.params.fix_mode = -1

      } else if (value === 2) {
        this.params.outputSize = 0
        this.params.fix_mode = 0

        this.params.colorType = -1
      }
    },
    // 获取压缩参数
    getCompressOptions() {
      let resize = this.checkRadio === 'sameScale' ? 'cover' : 'contain'
      return {
        resize: resize,
        width: !this.params.width ? 0 : this.params.width,
        height: !this.params.height ? 0 : this.params.height,
        scale: this.params.scale,
        dpi: this.params.dpi,
        size: this.params.size,
        molti: this.molti,
        fix_mode: this.params.fix_mode,
        modelType: this.params.modelType,
        colorType: this.params.colorType,
        outputSize: this.params.outputSize,
        colorShiftingOutputFormat: this.params.colorShiftingOutputFormat,
        handlingMethod: this.handlingMethod // 此参数决定启用压缩 还是 改变宽高， edit：改变宽高，compress：启用压缩
      }
    },

    handleClickRight() {
      this.isShowTips = false
    },

    async onUploadSuccess(file) {
      let supportTypes = []
      let suffixArray = this.accept.split(',')
      suffixArray.forEach(item => {
        let format = item.split('.')[1]
        supportTypes.push(formatTypes[format])
      })
      if (!supportTypes.includes(file.type)) {
        Message({
          type: 'error',
          message: '请上传指定的格式！'
        })
        return
      }
      let maxSize = this.maxSize * 1024 * 1024
      if (['upcolor','clearness-amplification', 'lossless-amplification'].includes(this.$route.name)) {
        let {width, height} = await getImageFileSize(file)
        if (width > 4096 || height > 4096) {
          Message.error(`请上传${this.maxSize}M，宽高均为4096px以内的图片`)
          return
        }
        maxSize = 30 * 1024 * 1024
      }
      if (file.size > maxSize) {
        if (['upcolor','clearness-amplification', 'lossless-amplification'].includes(this.$route.name)) {
          Message.error(`请上传${this.maxSize}M，宽高均为4096px以内的图片`)
        } else {
          this.isShowExceedTips = true
        }

        return
      }
      const options = this.getCompressOptions()
      let l = this.files.length
      if (l > this.limit - 1) {
        this.onUploadExceed()
        return
      }
      this.files.push({
        raw: file,
        options: options
      })
      if (this.isExecute) {
        // 如果执行过立即修改，则后续上传都要修改
        this.$nextTick(async () => {
          this.$refs.cardRef.forEach((vm, idx) => {
            if (idx > l - 1) {
              // 如果我上传多张图片，则后续的长度执行压缩
              vm.executeCompress({ options })
            }
          })
        })
      }
    },
    // 上传文件超出数量限制
    onUploadExceed() {
      this.isShowTips = true
    },
    // 重新上传
    handleReUpload() {
      let isStatus = this.$refs.cardRef.some(item => {
        return item?.fileInfo?.status === 'success'
      })
      if (this.files.length > 0 && isStatus) {
        // 如果当前列表中还有修改成功的图片，则提示用户
        this.isShowReUploadTips = true
        return
      }
      this.resetData()
    },
    resetData() {
      this.checkRadio = 'sameScale' // 默认选择等比例缩放
      this.params = {
        scale: 100,
        width: undefined,
        height: undefined,
        dpi: 72,
        size: 0,
        fix_mode: -1,
        colorType: 1,
        modelType: 1,
        outputSize: -1,
        colorShiftingOutputFormat: 0
      }
      this.reduceMBUnit = 0
      this.files = []
      this.isExecute = false
      this.denoise = true
      this.molti = this.$route.name === 'lossless-amplification' ? '4' : '0'
    },

    // 下载当前图片
    async downloadFile(fileInfo) {
      if (fileInfo.status !== 'success') {
        return
      }
      let downloadFiles = [
        {
          fid: fileInfo.origin.fid,
          raw: fileInfo.target.raw,
          filename: fileInfo.origin.filename,
          suffix: fileInfo.target.suffix,
          isDownload: fileInfo.isDownload,
          dl_token: fileInfo.target.dl_token
        }
      ]
      await this.downloadFn(downloadFiles, 'single')
    },

    // 点击全部下载
    async handleDownloadAll() {
      let downloadFiles = []
      this.$refs.cardRef.forEach((item, idx) => {
        let { suffix, raw } = item.fileInfo.target
        let { filename, fid } = item.fileInfo.origin
        if (item.fileInfo?.status === 'success') {
          let newFilename = `${filename}_${idx}`
          downloadFiles.push({
            fid: fid,
            filename: newFilename,
            suffix,
            raw,
            isDownload: item.fileInfo.isDownload,
            dl_token: item.fileInfo.target.dl_token
          })
        }
      })
      await this.downloadFn(downloadFiles, 'batch')
    },

    async downloadFn(downloadFiles, type) {
      let flag = await this.checkAllowDownload()
      if (!flag) {
        return
      }
      if (!Array.isArray(downloadFiles) || downloadFiles.length === 0) {
        return
      }
      let writeRouter = ['laozhaopian', 'clearness-amplification', 'lossless-amplification', 'upcolor']
      if (writeRouter.includes(this.$route.name)) {
        // 这几个页面，只需要校验dl_token
        let task = []
        downloadFiles.forEach(file => {
          task.push(checkUserImage(file?.dl_token))
        })
        Promise.all(task).then(res => {
          let flag = res.some(resItem => resItem.data.status === 0)

          if (flag) {
            if (type === 'single') {
              singleDownload(downloadFiles)
            } else {
              batchDownload(downloadFiles)
            }
          } else {
            this.showPurchaseModal()
          }

        })

      }  else {
        // 筛选没有下载过的图片，用于扣除次数
        let notDownloadFiles = downloadFiles.filter(item => {
          return !item.isDownload
        })
        let isCanDownload = false
        let isDirectDownload = this.allCert?.vip !== VIP_LEVEL.NON_VIP && this.allCert?.vip !== VIP_LEVEL.COUNT_VIP
        if (notDownloadFiles === 0 || isDirectDownload) {
          isCanDownload = true
        } else {
          isCanDownload = notDownloadFiles.length <= this.allCert?.has_image_count

        }
        if (isCanDownload) {
            let res = await duce(notDownloadFiles.length) // 只需要扣除没有下载过的图片
            if (res.data.status === 0) {
              await this.updateUserInfo() // 更新用户权益
              this.$refs.cardRef.forEach(vm => {
                notDownloadFiles.forEach(item => {
                  if (item.fid === vm.fileInfo.origin.fid) {
                    vm.fileInfo.isDownload = true
                  }
                })

              })
              if (type === 'single') {
                await singleDownload(downloadFiles)
              } else {
                await batchDownload(downloadFiles)
              }
            } else if (res.data.status === 600) {
              this.showPurchaseModal()
            } else {
              Message({
                type: 'error',
                message: '下载失败'
              })
            }
        } else {
          // 提示用户去续费
          this.isShowExceedDownloadTips = true
        }
      }
    },
    // 开始压缩
    execute() {
      this.isExecute = true
      const options = this.getCompressOptions()
      this.$refs.cardRef.forEach(vm => {
        vm.executeCompress({ options })
      })
    },
    FangDaDownLoad() {
      let method = ''
      if (
              this.$route.name === 'lossless-amplification' ||
              this.$route.name === 'clearness-amplification'
      ) {
        // 图片放大
        method = METHODS.IMAGE_ENHANCE
      }

      // 判断用户是否登录
      if (!getToken()) {
        this.$store.dispatch('showLoginModal', {}, { root: true })
        return
      }
      // 判断是否有下载历史记录
      if (isEmpty(this.$store.state.pdfStore.downloadHistory)) {
        // 判断用户是不是vip
        if (!this.$store.getters.isVip) {
          this.$store.dispatch('showPurchaseModal', {}, { root: true })
          return
        }

        // 判断用户是不是次数VIP
        let isCountVIP =
                this.$store.getters.getAllCert?.vip === VIP_LEVEL.COUNT_VIP
        let isCanDownLoadIndex = this.$store.getters.getAllCert
        let isCanDownload = isCanDownLoadIndex.has_image_count >= 1

        if (isCountVIP && !isCanDownload) {
          this.$messageDialog({
            showLeft: false,
            showRight: !this.$store.state.isVip,
            leftBtnTxt: '残忍放弃',
            rightBtnTxt: '限时升级VIP',
            title: '温馨提示',
            content: '您的下载次数已用完！',
            onClose: () => {},
            onClickLeftBtn: () => {
              this.$store.dispatch('pdfStore/resetStore')
            },
            onClickRightBtn: () => {
              this.$store.dispatch('showPurchaseModal', {}, { root: true })
            }
          })
          return
        }
      }
      this.$store.dispatch('amplificationStore/imageEnhanceFunction', {
        molti: this.molti,
        method: method
      })
    },
    // 开始放大 //变清晰
    Amplification() {
      this.isExecute = true
      // this.isShowFangdaTips = true
      const options = this.getCompressOptions()
      this.$refs.cardRef.forEach(vm => {
        vm.executeCompress({ options })
      })
      // this.FangDapreview()
    },
  },
  async created() {
    await this.onRouterChange(this.$route)
  }
}
</script>
<style scoped lang="less">
@import url('./index.less');
</style>
